import { render, staticRenderFns } from "./PgaDataTable.vue?vue&type=template&id=114fcf4a&scoped=true&"
import script from "./PgaDataTable.vue?vue&type=script&lang=ts&"
export * from "./PgaDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./PgaDataTable.vue?vue&type=style&index=0&id=114fcf4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114fcf4a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VDataTable,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('114fcf4a')) {
      api.createRecord('114fcf4a', component.options)
    } else {
      api.reload('114fcf4a', component.options)
    }
    module.hot.accept("./PgaDataTable.vue?vue&type=template&id=114fcf4a&scoped=true&", function () {
      api.rerender('114fcf4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PgaDataTable.vue"
export default component.exports